import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-asset', 'labelInteractiveAsset', 'Interaktīvs līdzeklis');
